import React from "react"
import {Link} from "react-router-dom";

export default class Navlink extends React.PureComponent {

  render() {
    return (
      <li>
        <Link to={this.props.to}>{this.props.text}</Link>
      </li>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/Navlink.js